import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Field, Form } from 'react-final-form';
import { Col, Modal, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import {
  Card, CardBody,
} from '@/shared/components/Card';
import {
  FormButtonToolbar,
  FormContainer,
  FormGroup,
  FormGroupField,
  FormGroupLabel,
  FormHalfContainer,
} from '@/shared/components/form/FormElements';
import Checkbox from '@mui/material/Checkbox';
import { renderMaskedField } from '@/shared/components/form/FormField';
import { Button } from '@/shared/components/Button';
import { GlobalContext } from '../../../../context/GlobalContext';

const SignupAgent = ({
 onSubmit, setCheckedTandC, checkedTandC, loading, 
}) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedAdressProof, setSelectedAdressProof] = useState(null);
  const [selectedGstProof, setSelectedGSTProof] = useState(null);
  // const [checkedTandC, setCheckedTandC] = useState(false);
  const [openTCModal, setOpenTCModal] = useState(false);
  const [country, setCountry] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState('');
  const { apiGlobal } = useContext(GlobalContext);
  const History = useHistory();

  const handleBack = () => {
    History.push('/');
  };

  
  const handleFileChange = (event, input) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
      input.onChange(file);
    } else {
      setSelectedImage(null);
      input.onChange(null);
    }
  };

  const handAddressFileChange = (event, input) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedAdressProof(reader.result);
      };
      reader.readAsDataURL(file);
      input.onChange(file);
    } else {
      setSelectedAdressProof(null);
      input.onChange(null);
    }
  };

  const handGstFileChange = (event, input) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedGSTProof(reader.result);
      };
      reader.readAsDataURL(file);
      input.onChange(file);
    } else {
      setSelectedGSTProof(null);
      input.onChange(null);
    }
  };
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

  const tchandler = (e) => {
    const { checked } = e.target;
    setCheckedTandC(checked);
  };


  const fetchtermsAndConditions = async () => {
    try {
      const url = await fetch(`${apiGlobal}/terms_condition_data.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        // body: JSON.stringify({
        //   id: 1,
        // }),
      });
      const data = await url.json();
      if (data.status && data.message === 'Success') {
        // console.log(data);
        setTermsAndConditions(data.data[0]?.terms || 'hello');
        // console.log(data.data[0]?.terms);
      } else {
        setTermsAndConditions('');
      }
    } catch (error) {
      console.error('Error fetching terms and conditions:', error);
    }
  };
  useEffect(() => {
    fetchtermsAndConditions();
  }, []);

  const fetchCountryList = async () => {
    setIsLoading(true);
      try {
        const url = await fetch(`${apiGlobal}/currency_master_list.php`, {
          method: 'POST',
        });
        const response = await url.json();
        if (response.status && response.message === 'Success') {
          setCountry(response?.data);
        } else {
          setCountry([]);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
  
    useEffect(() => {
      fetchCountryList();
    }, []);


    const validateGSTIN = (value) => {
      if (!value) return 'GST No is required';
      const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      if (!gstinRegex.test(value.toUpperCase())) {
        return 'Invalid GST No format';
      }
      return undefined;
    };

  return (
    <Col md={12} lg={12}>
      
    
      <Form onSubmit={onSubmit} horizantal initialValues={{ gender: 'male' }}>
        {({ handleSubmit, form }) => (
          <FormContainer onSubmit={handleSubmit}>
            <Card>
              <CardBody>
                <p><span style={{ color: 'red' }}>*</span> Mark Fields are required.</p>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Agent Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="agentName"
                          component="input"
                          type="text"
                          placeholder="Name"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Email Address<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="email"
                          component="input"
                          type="email"
                          placeholder="Email Address"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Phone Number<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <div style={{ display: 'flex', width: '100%', gap: '10px' }}>
                          {/* Country Code Select */}
                          <Field
                            name="countryCode"
                            render={({ input, meta }) => (
                              <div>
                                <Select
                                  {...input}
                                  options={country.map(item => ({
                                  value: item.id,
                                  label: item.country_code,
                                }))}
                                  isLoading={isLoading}
                                  placeholder="Code"
                                  classNamePrefix="react-select"
                                  components={{
                                  DropdownIndicator: () => null,
                                  IndicatorSeparator: () => null,
                                }}
                                  styles={{
                                  control: provided => ({
                                    ...provided,
                                    width: '70px',
                                    height: '45px',
                                    borderRadius: '5px',
                                  }),
                                  menu: provided => ({
                                    ...provided,
                                    width: '70px',
                                    zIndex: 9999,
                                  }),
                                  option: provided => ({
                                    ...provided,
                                    width: '70px',
                                  }),
                                }}
                                />
                                {meta.touched && meta.error && (
                                <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                                  )}
                              </div>
                            )}
                          />

                          {/* Phone Input */}
                          <Field
                            name="phone_no"
                            render={({ input, meta }) => (
                              <div style={{ flex: 1 }}>
                                <input
                                  {...input}
                                  type="text"
                                  inputMode="numeric"
                                  // pattern="\d{12}"
                                  maxLength={12}
                                  placeholder="Enter Phone Number"
                                  style={{
                                  width: '100%',
                                  height: '45px',
                                  padding: '10px',
                                  borderRadius: '5px',
                                  border: '1px solid gray',
                                }}
                                  onInput={(e) => {
                                  e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12);
                                  input.onChange(e.target.value);
                                }}
                                />
                                {meta.touched && meta.error && (
                                <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                              )}
                              </div>
                            )}
                            // validate={value =>
                            //  (value && value.length === 12 ? undefined : '12 digit phone required')}
                          />
                        </div>

                        {/* <Field name="countryCode">
                          {({ input, meta }) => (
                            <div>
                              <select
                                {...input}
                                style={{
                              height: '45px',
                              backgroundColor: 'white',
                              border: '1px solid gray',
                              width: '100%',
                              borderRadius: '5px',
                              paddingLeft: '10px',
                            }}
                                required
                              >
                                <option value="">Select Country Code</option>
                                {country.map(nation => (
                                  <option key={nation.id} value={nation.id}>
                                    {nation.country_code}
                                  </option>
                                                      ))}
                              </select>
                              {meta.touched && meta.error && (
                              <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                                                    )}
                            </div>
                                                  )}
                        </Field>
                        <Field
                          name="phone_no"
                          component="input"
                          type="number"
                          inputMode="numeric" // mobile-friendly numeric keyboard
                          pattern="\d{1,12}"
                          maxLength={12} // limit to 15 digits
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12);
                          }}
                          placeholder="Enter 12 digit Phone Number"
                          required
                          style={{ height: '45px' }}
                        /> */}
                      </FormGroupField>
                    </FormGroup>
                  </Col> 
                </Row>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>UAN<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="uan"
                          component="input"
                          type="number"
                          inputMode="numeric" // mobile-friendly numeric keyboard
                          maxLength={12} 
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12);
                          }}
                          placeholder="UAN"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Location<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="location"
                          component="input"
                          type="text"
                          placeholder="Location"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Address line 1<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="addressline1"
                          component="input"
                          type="text"
                          placeholder="Address Line 1"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Address line 2</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="addressline2"
                          component="input"
                          type="text"
                          placeholder="Address Line 2"
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                    
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Area<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="area"
                          component="input"
                          type="text"
                          placeholder="Area"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>City<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="city"
                          component="input"
                          type="text"
                          placeholder="City"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>State<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="state"
                          component="input"
                          type="text"
                          placeholder="State"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Pincode<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="pincode"
                          component="input"
                          type="number"
                          inputMode="numeric" // mobile-friendly numeric keyboard
                          maxLength={6} 
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 6);
                          }}
                          placeholder="Pincode"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Select Country<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="country"
                          render={({ input, meta }) => (
                            <Select
                              {...input} 
                              name="country"
                              style={{ height: '40px' }}
                              options={country.map(item => ({
                                value: item.id,
                                label: item.country_name,
                              }))}
                              isLoading={isLoading}
                              className="react-select w-100"
                              classNamePrefix="react-select"
                              placeholder="Select a Country"
                              styles={{
                                width: '100%',
                            control: provided => ({
                              ...provided,
                             
                            }),
                            singleValue: provided => ({
                              ...provided,
                              
                            }),
                          }}
                            />
                      )}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Logo<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="file"
                          style={{ height: '45px' }}
                          render={({ input }) => (
                            <input
                              type="file"
                              onChange={e => handleFileChange(e, input)}
                              required
                            />
                          )}
                        />
                      </FormGroupField>
                    </FormGroup>
                    {selectedImage && (
                    <FormGroup>
                      <FormGroupLabel>Selected Logo</FormGroupLabel>
                      <FormGroupField>
                        <img
                          src={selectedImage}
                          alt="Selected Logo"
                          style={{ maxWidth: '200px', maxHeight: '200px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  )}
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>Address Proof</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          style={{ height: '45px' }}
                          name="address_proof"
                          render={({ input }) => (
                            <input
                              type="file"
                              onChange={e => handAddressFileChange(e, input)}
                            />
                        )}
                        />
                      </FormGroupField>
                    </FormGroup>
                    {selectedAdressProof && (
                    <FormGroup>
                      <FormGroupLabel>Selected Address Proof</FormGroupLabel>
                      <FormGroupField>
                        <img
                          src={selectedAdressProof}
                          alt="Selected Address Proof"
                          style={{ maxWidth: '200px', maxHeight: '200px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  )}
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>GST Proof</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          style={{ height: '45px' }}
                          name="gst_proof"
                          render={({ input }) => (
                            <input
                              type="file"
                              onChange={e => handGstFileChange(e, input)}
                            />
                        )}
                        />
                      </FormGroupField>
                    </FormGroup>
                    {selectedGstProof && (
                    <FormGroup>
                      <FormGroupLabel>Selected GST Proof</FormGroupLabel>
                      <FormGroupField>
                        <img
                          src={selectedGstProof}
                          alt="Selected Address Proof"
                          style={{ maxWidth: '200px', maxHeight: '200px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  )}
                  </Col>
                </Row>
                <Row>

                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>GST No</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="gst_no"
                          component="input"
                          type="text"
                          maxLength={15}
                          parse={value => value?.toUpperCase()} // Auto-uppercase
                          // validate={validateGSTIN}
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>GST Type</FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="gst_type"
                          component="input"
                          type="text"
                          placeholder="GST Type"
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>TAX Identification<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="taxId"
                          component="input"
                          type="text"
                          placeholder="TAX Identification"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <FormGroupLabel>TAX City<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="taxCity"
                          component="input"
                          type="text"
                          placeholder="Tax City"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </Col>
                </Row>

                <div>
                 
                  <div style={{
                display: 'flex',
                flexWrap: 'wrap',
              }}
                  >
                    <div style={{
                display: 'flex', alignItems: 'center', gap: '8px', marginTop: '12px', 
                }}
                    >
                      <Checkbox {...label} color="success" onChange={tchandler} />
                      <p style={{ margin: 0 }}>
                        I agree <span style={{ color: 'red' }}>*</span>
                      </p>
                    </div>

                    {/* eslint-disable-next-line */}
              <a 
                onClick={() => setOpenTCModal(true)} 
                className="text-primary"
                style={{
                  textDecorationLine: 'underline',
                  marginTop: '23px',
                  marginLeft: '10px',
                  cursor: 'pointer',
                }}
              >
                
                Click here to View Terms and Condition
              </a> 
                  </div> 
                  <FormButtonToolbar>
                   
                    <Button variant="primary" type="submit" disabled={!checkedTandC || loading}>Submit</Button>
                    <Button variant="secondary" type="button" onClick={form.reset}>
                      Reset
                    </Button>
                    <Button variant="danger" type="button" onClick={handleBack}>Back to Login</Button>
                  </FormButtonToolbar>
                </div>
              </CardBody>
            </Card>
          </FormContainer>
            )}
      </Form>
       
      {/* Modal for TC */}
      <Modal
        show={openTCModal}
        onHide={() => setOpenTCModal(false)}
        centered
        size="lg"
        backdrop="static" // Prevent clicking outside the modal to close it
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Accept terms and Condition</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Terms and Conditions <br />
            <div
              style={{ lineHeight: '1.8', fontSize: '16px' }}
              dangerouslySetInnerHTML={{ __html: termsAndConditions }}
            />
          </p>
        </Modal.Body>
      </Modal>
    </Col>
  );
};

SignupAgent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  setCheckedTandC: PropTypes.func.isRequired,
  checkedTandC: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,

};

export default SignupAgent;
